import { TradeItem, Trades } from '@libs/api-reference';
import { computed } from 'vue';
import { useQueryV2 } from '@libs/use';
import {
  calcSymbolBuyValue,
  calcSymbolSellValue,
  useSymbolDeductions,
} from '@core/symbol';

import * as API from '../requests';
import { ORDER_SIDES, ORDERS_QUERY_KEYS } from '../constants';

export default function useGetMicroTransactionsQuery(
  orderId: string,
  isLegacy = false
) {
  const { findWageConfigBySymbol } = useSymbolDeductions();

  const {
    result,
    execute: getMicroTransactions,
    isPending: isLoadingTransactions,
    isRevalidating: isRevalidatingTransactions,
    ...query
  } = useQueryV2<Trades>(
    () =>
      !isLegacy
        ? API.getNewMicroTransactions(orderId)
        : API.getMicroTransactions(orderId),
    {
      key: ORDERS_QUERY_KEYS.trades(orderId),
    }
  );

  const microTransactionsList = computed<TradeItem[]>(() => {
    const resultData = result.value?.data?.items || [];

    return resultData.map((trade) => {
      const wage = findWageConfigBySymbol(trade);

      const value =
        Number(trade.tradeSidedId) === ORDER_SIDES.buy
          ? calcSymbolBuyValue(
              {
                price: trade.price,
                quantity: trade.quantity,
              },
              wage
            )
          : calcSymbolSellValue(
              {
                price: trade.price,
                quantity: trade.quantity,
              },
              wage
            );

      return {
        ...trade,
        value,
      };
    });
  });

  return {
    getMicroTransactions,
    microTransactionsList,
    isLoadingTransactions,
    isRevalidatingTransactions,
    ...query,
  };
}
